// extracted by mini-css-extract-plugin
export default {"subContainer":"styles_subContainer__SXfmT","mainContainerForm":"styles_mainContainerForm__Nuf1h","txtIntro":"styles_txtIntro__aNsAd"};